import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_59: FaireProductEntity = {
  token: "catalog_prod_prod-59",
  type: "product",
  name: "Curved Base Table Lamp with Pleated Shade - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 28.23,
  msrpDollars: 70.58,
  sku: "JA0059",
  caseSize: 4,
  material: "Linen",
  collectionToken: "col_japandi",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: false,
  stockLevel: 58,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_stickers-pins"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
